module.exports = __webpack_public_path__ + "static/media/corporate-services-img78.3649d5e4.jpg";